import { createContext, useContext } from "react";
import { Range } from "../../types/range";
import { Handler } from "../../types/handler";

export type ClipState = {
  show: boolean;
  activeHandler?: Handler;
  rangeInPixels: Range;
  rangeInTime: Range;
};

export const ClipContext = createContext<ClipState | undefined>(undefined);

export const useClip = () => {
  const context = useContext(ClipContext);

  if (context === undefined) {
    throw new Error("useClip must be used within a ClipProvider");
  }

  return context;
};
